import { OrganizationGroupOrganizationDTO, OrganizationGroupSummaryDTO } from '@reposit/api-client';
import { DeleteOrganizationGroupPayload, OrganizationGroupManagementFilters } from './organization-group-management.types';

export const SEARCH_ORG_GROUP_ORGANIZATIONS_STORE_KEY = 'ORGANIZATION_GROUPS/SEARCH_ORGANIZATIONS';
export const SEARCH_ORG_GROUP_ORGANIZATIONS_API_REQUESTED = 'ORGANIZATION_GROUPS/SEARCH_ORGANIZATIONS_API_REQUESTED';
export const SEARCH_ORG_GROUP_ORGANIZATIONS_API_SUCCESS = 'ORGANIZATION_GROUPS/SEARCH_ORGANIZATIONS_API_SUCCESS';
export const SEARCH_ORG_GROUP_ORGANIZATIONS_API_FAILED = 'ORGANIZATION_GROUPS/SEARCH_ORGANIZATIONS_API_FAILED';
export const RESET_ORG_GROUP_ORGANIZATIONS = 'ORGANIZATION_GROUPS/RESET_ORGANIZATIONS';
export const CANCEL_ORG_GROUP_MANAGEMENT_SEARCHES = 'ORGANIZATION_GROUPS/CANCEL_MANAGEMENT_SEARCHES';
export const ORG_GROUP_ORGANIZATIONS_GOTO_PAGE = 'ORGANIZATION_GROUPS/ORGANIZATIONS_GOTO_PAGE';
export const UPDATE_ORG_GROUP_ORGANIZATION_FILTERS = 'ORGANIZATION_GROUPS/UPDATE_ORGANIZATION_FILTERS';

export const SEARCH_UNUSED_ORG_GROUPS_STORE_KEY = 'ORGANIZATION_GROUPS/SEARCH_UNUSED';
export const SEARCH_UNUSED_ORG_GROUPS_API_REQUESTED = 'ORGANIZATION_GROUPS/SEARCH_UNUSED_API_REQUESTED';
export const SEARCH_UNUSED_ORG_GROUPS_API_SUCCESS = 'ORGANIZATION_GROUPS/SEARCH_UNUSED_API_SUCCESS';
export const SEARCH_UNUSED_ORG_GROUPS_API_FAILED = 'ORGANIZATION_GROUPS/SEARCH_UNUSED_API_FAILED';
export const UNUSED_ORG_GROUPS_GOTO_PAGE = 'ORGANIZATION_GROUPS/UNUSED_GOTO_PAGE';

export const DELETE_ORG_GROUP_STORE_KEY = 'ORGANIZATION_GROUPS/DELETE';
export const DELETE_ORG_GROUP_API_REQUESTED = 'ORGANIZATION_GROUPS/DELETE_API_REQUESTED';
export const DELETE_ORG_GROUP_API_SUCCESS = 'ORGANIZATION_GROUPS/DELETE_API_SUCCESS';
export const DELETE_ORG_GROUP_API_FAILED = 'ORGANIZATION_GROUPS/DELETE_API_FAILED';

export function searchOrganizationGroupOrganizationsRequested() {
  return {
    type: SEARCH_ORG_GROUP_ORGANIZATIONS_API_REQUESTED,
  } as const;
}

export type Page = number | 'next' | 'prev';

export function goToOrganizationGroupOrganizationsPage(page: Page) {
  return {
    type: ORG_GROUP_ORGANIZATIONS_GOTO_PAGE,
    payload: page,
  } as const;
}

export function updateOrganizationGroupOrganizationFilters(filters: Partial<OrganizationGroupManagementFilters>) {
  return {
    type: UPDATE_ORG_GROUP_ORGANIZATION_FILTERS,
    payload: filters,
  } as const;
}

export function searchOrganizationGroupOrganizationsSuccess(count: number, results: OrganizationGroupOrganizationDTO[]) {
  return {
    type: SEARCH_ORG_GROUP_ORGANIZATIONS_API_SUCCESS,
    payload: {
      count,
      results,
    },
  } as const;
}

export function searchOrganizationGroupOrganizationsFailed(error: string) {
  return {
    type: SEARCH_ORG_GROUP_ORGANIZATIONS_API_FAILED,
    payload: error,
  } as const;
}

export function resetOrganizationGroupOrganizations() {
  return {
    type: RESET_ORG_GROUP_ORGANIZATIONS,
  } as const;
}

export function cancelOrganizationGroupManagementSearches() {
  return {
    type: CANCEL_ORG_GROUP_MANAGEMENT_SEARCHES,
  } as const;
}

export function searchUnusedOrganizationGroupsRequested() {
  return {
    type: SEARCH_UNUSED_ORG_GROUPS_API_REQUESTED,
  } as const;
}

export function goToUnusedOrganizationGroupsPage(page: Page) {
  return {
    type: UNUSED_ORG_GROUPS_GOTO_PAGE,
    payload: page,
  } as const;
}

export function searchUnusedOrganizationGroupsSuccess(count: number, results: OrganizationGroupSummaryDTO[]) {
  return {
    type: SEARCH_UNUSED_ORG_GROUPS_API_SUCCESS,
    payload: {
      count,
      results,
    },
  } as const;
}

export function searchUnusedOrganizationGroupsFailed(error: string) {
  return {
    type: SEARCH_UNUSED_ORG_GROUPS_API_FAILED,
    payload: error,
  } as const;
}

export function deleteOrganizationGroupRequested(payload: DeleteOrganizationGroupPayload) {
  return {
    type: DELETE_ORG_GROUP_API_REQUESTED,
    payload,
  } as const;
}

export function deleteOrganizationGroupSuccess(id: string) {
  return {
    type: DELETE_ORG_GROUP_API_SUCCESS,
    payload: id,
  } as const;
}

export function deleteOrganizationGroupFailed(error: string) {
  return {
    type: DELETE_ORG_GROUP_API_FAILED,
    payload: error,
  } as const;
}

export type OrganizationGroupManagementActionTypes = ReturnType<
  | typeof searchOrganizationGroupOrganizationsRequested
  | typeof goToOrganizationGroupOrganizationsPage
  | typeof updateOrganizationGroupOrganizationFilters
  | typeof searchOrganizationGroupOrganizationsSuccess
  | typeof searchOrganizationGroupOrganizationsFailed
  | typeof resetOrganizationGroupOrganizations
  | typeof cancelOrganizationGroupManagementSearches
  | typeof searchUnusedOrganizationGroupsRequested
  | typeof goToUnusedOrganizationGroupsPage
  | typeof searchUnusedOrganizationGroupsSuccess
  | typeof searchUnusedOrganizationGroupsFailed
  | typeof deleteOrganizationGroupRequested
  | typeof deleteOrganizationGroupSuccess
  | typeof deleteOrganizationGroupFailed
>;
